import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SignForm from 'components/SignForm';
import { saveNewPasswordToken } from 'redux/actions';

const NewPassword = () => {
    const { pathname } = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const _path = pathname.split('/');

        dispatch(saveNewPasswordToken(_path[2]));
    }, [pathname, dispatch]);

    return <SignForm />;
};

export default NewPassword;
